import { ClientManagerForm } from "../../../../Components/secure/clientManager/ClientManagerForm";
import { Container, Divider, Header } from "semantic-ui-react";
import { useTranslation } from "react-i18next"

export const CreateClientManager = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Header as="h1">{t("ClientManager.New")}</Header>
      <Divider />
      <ClientManagerForm />
    </Container>
  )
}